export class Prodotto {
  key?: string | null;
  name?: string;
  description?: string;
  price?:number;
  available?: boolean;
  url?:string;
}
